/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import appConfig from 'app-config';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import { MLLOBDisplayService, MLAgentChoiceReportService } from 'gw-capability-gateway';
import { WizardContext } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLBundleService, MLMultiLobsDataHolderService, MLStateRolloutService } from 'ml-services-common-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { LoadSaveService, CustomQuoteService as GatewayCustomQuoteService } from 'gw-capability-gateway-quoteandbind';
import messages from './MlBundleWidget.messages';
import styles from './MlBundleWidget.module.scss';
import wizardStyles from '../WizardSidebar.module.scss';
import { Link } from '@jutro/router';
import { MLErrorMessageUtil } from 'ml-portals-util-js';

import { IntlContext } from '@jutro/legacy/locale';

function getTotal(submissions) {
    const total = { currency: 'usd', amount: 0 };
    submissions.forEach((submission) => {
        if (submission.totalPremium) {
            total.amount += submission.totalPremium.amount;
        }
    });
    return total;
}


function showGoToCart () {
    return !MLBundleService.inPostQuote();
}

function MlBundleWidget(props) {
    const {
        history,
        accountNumber
    } = props;

    const [submissionData, setSubmissionData] = useState([...MLBundleService.getJobs()]);
    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const wizardContext = useContext(WizardContext);
    const { authHeader } = useAuthentication();
    const { portalCode } = appConfig;
    const {
        wizardData,
        wizardSnapshot 
    } = wizardContext;
    

    const _handleBundleError = (error) => {
        console.error(error);
    };

    const updateJobs = () => {
        setSubmissionData([...MLBundleService.getJobs()])
    }

    useEffect(() => {
        async function refreshJobs(){
            try{
                await MLBundleService.refreshBundleSummary(accountNumber, authHeader);
                setSubmissionData([...MLBundleService.getJobs()])
            }catch(error){
                _handleBundleError(error);
            };
        }
        refreshJobs();

        if (window.addEventListener) {
            window.addEventListener('MLBundleWidget_updateJobs', updateJobs, false);
        } else {
            window.attachEvent('MLBundleWidget_updateJobs', updateJobs);
        }
        return () => {
            if(window.addEventListener){
                window.removeEventListener('MLBundleWidget_updateJobs', updateJobs, false);
            } else if (window.attachEvent){
                window.detachEvent('MLBundleWidget_updateJobs', updateJobs);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const BOOKROLL_WITH_RATE_CAPPING = 'with_Rate_Capping';
    const BOOKROLL_WITHOUT_RATE_CAPPING = 'without_ratecapping';

    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const {
        showReportModalWithSubmissionVM
    } = MLAgentChoiceReportService();

    function consumeCallbacksSequentially (callbackQueue, runOnCompletion, runOnError) {
        if (callbackQueue.length > 0) {
            callbackQueue.shift()().then(
                () => consumeCallbacksSequentially(callbackQueue, runOnCompletion, runOnError),
                (err) => {
                    console.error(err);
                    if (runOnError) {
                        runOnError(err);
                    }
                });
        } else if (runOnCompletion) {
            runOnCompletion();
        }
    }

    const getQuoteCoverages = (submissionVM, lobPathString, quote) => {
        const offerings = _.get(submissionVM, `lobData.${lobPathString}.offerings.value`, []);
        const selectedOffering = offerings.find((o) => o.branchCode === quote.branchCode && o.branchName === quote.branchName
            && o.branchPublicID === quote.publicID);
        return _.get(selectedOffering, 'coverages');
    };

    function goToCart() {
        const promise = new Promise((resolve, reject) => {
            if (portalCode === 'GPA') {
                if (wizardData.isChoiceAgentSubmission_ML.value) {
                    showReportModalWithSubmissionVM(wizardData);
                }
            }
            const periodStatus = _.get(wizardData, 'baseData.periodStatus.value.code');
            if (wizardData.baseData.policyAddress.value.state === 'AK' && wizardData.baseData.value.termType === '7Days') {
                resolve();
            }
            if (wizardData.bookrollInd_ML.value && wizardData.bookrollInd_ML.value.code === BOOKROLL_WITH_RATE_CAPPING || wizardData.bookrollInd_ML.value.code === BOOKROLL_WITHOUT_RATE_CAPPING) {
                resolve();
            }
            if (!wizardData.quoteID.value) {
                // no submission was created so just exit without saving
                resolve();
            }
            if (!wizardData.aspects.subtreeValid) {
                // invalid data when trying to exit wizard. Exiting without saving
                resolve();
            }
            if(periodStatus !== 'Quoted') {
                // As updateDraftSubmission is removing crucial properties that needed in CR PA Validate Info
                // page from the beforeSave method, so need to make a full clone of the submission data
                // to prevent data reference is lost when page re-render before leave page
                const copiedSubmission = _.cloneDeep(wizardData.value);
                return LoadSaveService.updateDraftSubmission(copiedSubmission, authHeader)
                .then(resolve)
                .catch(error => {
                    const bracketContent = error.baseError.match(/\[([^\]]+)\]/);
                    if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                        hideProgressDialog();
                        MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                    }else if(error.baseError){
                            if (bracketContent) {
                                hideProgressDialog();
                                showErrorModal('', bracketContent[1], messages.closeWindow);
                                return false
                            }else {
                                reject(error);
                            }

                    } else if(error.error.cause) {
                    hideProgressDialog();
                    showErrorModal(null, error.error.cause.message);
                    return false;
                    }
                });
            }
            if (wizardData.isBundle_ML && MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails') {
                if (portalCode === 'GPA') {
                    if(periodStatus === 'Quoted') {
                        if(wizardData.value.baseData.policyAddress!==wizardSnapshot.value.baseData.policyAddress){
                             return LoadSaveService.updateQuotedSubmission(wizardData.value, authHeader).then(resolve, reject);
                        }
                    }
                    const lobPathString = _.camelCase(_.get(wizardData, 'baseData.productName.value', ''));
                    const innerPromise = new Promise((innerResolve, innerReject) => {
                        const updateCallbackRequests = wizardData.value.quoteData.offeredQuotes
                            .map((quote) => {
                                const coverages = {
                                    [`${lobPathString}`]: getQuoteCoverages(wizardData, lobPathString, quote)
                                }
                                const updateCustomQuoteRequest = {
                                    quote,
                                    sessionUUID: wizardData.value.sessionUUID,
                                    quoteID: wizardData.value.quoteID,
                                    ratingPaymentMethod_ML: quote.ratingPaymentMethod_ML,
                                    ratingPaymentSchedule_ML: quote.ratingPaymentSchedule_ML,
                                    productCode_ML: wizardData.value.baseData.productCode,
                                    forcePaymentMethodSelection_ML: true,
                                    markAsSelectedVersion_ML: quote.publicID === wizardData.value.bindData.chosenQuote,
                                    coverages : coverages
                                };
                                return () => GatewayCustomQuoteService.updateCustomQuote(updateCustomQuoteRequest, authHeader);
                            });
            
                        consumeCallbacksSequentially(
                            updateCallbackRequests,
                            () => innerResolve(),
                            (err) => innerReject(err)
                        );
                    })
                    innerPromise.then(resolve, reject);
                    return innerPromise;
                }
            }
    
            if (wizardData.isBundle_ML &&
                wizardData.isBundle_ML.value &&
                (MLMultiLobsDataHolderService.getLastVisitedStep() === 'availableDocuments' ||
                MLMultiLobsDataHolderService.getLastVisitedStep() === 'signAndBind')) {
                return LoadSaveService.preBind(wizardData.value, authHeader).then(resolve, reject);
            }
    
            if(periodStatus === 'Quoted') {
                return LoadSaveService.updateQuotedSubmission(wizardData.value, authHeader).then(resolve, reject);
            }
        });

        showProgressDialog(platformMessages.saveSubmission, promise);

        promise.then(() => {
            MLTagManagerService.sendBundleFormCompleteEvent();
            MLBundleService.checkIsCRBridgedQuote(wizardData.value.quoteID, authHeader)
                .then((isCRBridgeQuote) => {
                    // Check if it is CR bundle
                    if (!isCRBridgeQuote) {
                        history.push(`/agent-bundle-cart/${wizardData.value.baseData.accountNumber}`);
                    } else {
                        MLStateRolloutService.checkIsCRWizardEligible(wizardData.value.quoteID, authHeader)
                            .then((isCREligible) => {
                                if(isCREligible) {
                                    history.push(`/comp-wizard/${wizardData.value.quoteID}`, {
                                        submissionNumber: wizardData.value.quoteID,
                                        bridgedQuotes: isCRBridgeQuote
                                    });
                                }
                                else {
                                    history.push(`/agent-bundle-cart/${wizardData.value.baseData.accountNumber}`);
                                }
                            });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    if (error?.baseError && error?.baseError?.indexOf('ConcurrentDataChangeException') > -1) {
                        hideProgressDialog();
                        MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                    }
                });
        })
        .catch((error) => {
            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
        })
        .finally(()=> {
            hideProgressDialog();
        })
    }

    return (
        <div>
            <div className="ml-leftrail-nav__header-section vertical-spacing-20 clearfix">
                <div className="ml-leftrail-nav__header-section-icon">
                    <span className="icon-ml-icon-package" />
                </div>
                <div className="ml-leftrail-nav__header-section-content clearfix">
                    <div className={styles["container-fluid"]}>
                        <div className="row no-gutter">
                            <div className="col-md-6">
                                <h2 className={classNames(wizardStyles.whiteLink)}>{translator(messages.bundleTotal)}</h2>
                                {showGoToCart() && <Link onClick={goToCart}>{translator(messages.editBundle)}</Link>}
                            </div>

                            <div className="col-md-6 text-align-right">
                                <h2 className={classNames(wizardStyles.whiteLink)}>{MLBundleService.formatPremium(getTotal(submissionData), intl)}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="vertical-spacing-10 clearfix">
                <div className={styles.bundleWidgetContainer}>
                    <div className={styles["container-fluid"]}>
                        {submissionData.map((submission, index) => {
                            return (
                                <div>
                                    <div className={classNames(styles.bundleWidget, styles["border-bottom"], "row display-flex", { "vertical-spacing-10" : index < submissionData.length-1})}>
                                        <div className="col-xs-4 vertical-spacing-10">
                                            <p className="header-light">{MLLOBDisplayService.getLOBPolicyName(submission)}</p>
                                            <p className="header-light">{submission.jobNumber}</p>
                                        </div>

                                        <div className="col-xs-4 vertical-spacing-10">
                                            <p className="header-light text-align-center">{MLBundleService.getStatus(submission).displayName}</p>
                                            <p className="header-light text-align-center" />
                                        </div>

                                        <div className="col-xs-4 vertical-spacing-10">
                                            <p className={classNames(styles.premium, "header-light text-align-right")}>{MLBundleService.formatPremium(submission.totalPremium, intl)}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

MlBundleWidget.propTypes = {
    submissionData: PropTypes.shape([{}])
};
MlBundleWidget.defaultProps = {
    submissionData: [{}]
};
export default withRouter(MlBundleWidget);